export type GetAccessTokenFn = () => Promise<string | undefined>

let provider: GetAccessTokenFn | undefined
const listeners = new Set<() => void>()

export const setGetAccessTokenProvider = (fn: GetAccessTokenFn): void => {
    provider = fn
    listeners.forEach((l) => {
        try { l() } catch { /* noop */ }
    })
}

export const getGetAccessTokenProvider = (): GetAccessTokenFn | undefined => {
    return provider
}

export const onAuthProviderSet = (fn: () => void): () => void => {
    listeners.add(fn)
    return (): void => { listeners.delete(fn) }
}
